import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';
import { useFavorites } from '../../context/FavoritesContext';
import { useCustomerAuth } from '../../context/CustomerAuthContext';
import ProductCard from '../../components/ProductCard';

const formatPrice = (p) => new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 0 }).format(p);

export default function Favorites() {
    const { customer } = useCustomerAuth();
    const { favorites, toggleFavorite } = useFavorites();

    if (!customer) {
        return (
            <div className="favorites-page">
                <div className="favorites-empty">
                    <Heart size={48} strokeWidth={1} />
                    <h2>Favorilerinizi görmek için giriş yapın</h2>
                    <p>Beğendiğiniz ürünleri favorilere ekleyip daha sonra kolayca ulaşabilirsiniz.</p>
                    <Link to="/giris" className="favorites-login-btn">Giriş Yap</Link>
                </div>
            </div>
        );
    }

    return (
        <div className="favorites-page">
            <div className="favorites-header">
                <h1>Favorilerim</h1>
                <span className="favorites-count">{favorites.length} ürün</span>
            </div>

            {favorites.length === 0 ? (
                <div className="favorites-empty">
                    <Heart size={48} strokeWidth={1} />
                    <h2>Henüz favoriniz yok</h2>
                    <p>Beğendiğiniz ürünlerin kalp ikonuna tıklayarak favorilerinize ekleyebilirsiniz.</p>
                    <Link to="/urunler" className="favorites-login-btn">Ürünleri Keşfet</Link>
                </div>
            ) : (
                <div className="favorites-grid">
                    {favorites.map(fav => {
                        const product = fav.product;
                        if (!product) return null;
                        return (
                            <ProductCard
                                key={fav.id}
                                product={product}
                                formatPrice={formatPrice}
                                isFavorited={() => true}
                                toggleFavorite={toggleFavorite}
                                showRating={false}
                                showVariantColors={false}
                            />
                        );
                    })}
                </div>
            )}
        </div>
    );
}
